export default "__VITE_ASSET__0GKrspvn__"